export const CHECK_IN_CONSTANTS = {
  minCharNeeded: 4,
}
